import { formatDate, formatDate2, ResolutionTypeToText, getCustomerResolutionTypeText } from '../../../helpers';
import { Claims } from '@database/types';

import { BaseModel } from './base.model';
import { ClaimItemModel } from './claim-item.model';

export class ClaimResolutionModel extends BaseModel<any> {
  get id() {
    return this._data.id;
  }

  get claim() {
    return this._data.claim;
  }

  get relatedClaimItemId() {
    return this._data.relatedClaimItemId;
  }

  get order() {
    return this.claim.order;
  }

  get type() {
    return ResolutionTypeToText[this._data.resolutionType];
  }

  get typeForCustomer() {
    return getCustomerResolutionTypeText(this._data.resolutionType);
  }

  get details() {
    return this._data.details;
  }

  get user() {
    return this._data.user;
  }

  get providedResolution() {
    return this._data.resolutionType;
  }

  get quantity() {
    return this._data.quantity;
  }

  get refundedQuantity() {
    return this._data.refundedQuantity;
  }

  get validQuantity() {
    const quantity = this._data.orderItem?.quantity ?? 0;
    const refundedQuantity = this.refundedQuantity;
    const claimQuantity = this.quantity;
    const remainingQuantity = quantity - refundedQuantity;
    if (remainingQuantity === 0 || claimQuantity > remainingQuantity) {
      return remainingQuantity;
    }

    return claimQuantity;
  }

  get claimId() {
    return this.claim.id;
  }

  get lines() {
    return this._data.lines;
  }

  get claimItems(): ClaimItemModel[] {
    return (this.lines ?? [])
      .filter(l => l.lineType === Claims.ClaimResolutionLineType.ITEM && l.claimItem)
      .map(l => new ClaimItemModel({ ...l.claimItem, resolutionQuantity: l.quantity, resolutionType: l.resolutionType, claim: this.claim }));
  }

  get shippingAmount() {
    const shippingLine = this.lines?.find(l => l.lineType === Claims.ClaimResolutionLineType.SHIPPING);
    return shippingLine?.resolvedAmount ?? 0;
  }

  get creditStore() {
    return this._data.creditStore;
  }

  get resolvedAmount() {
    return this._data.totalAmount;
  }

  get reimbursedAmount() {
    // creditedAmount is the matrix-adjusted amount OP reimburses the store (computed at resolution).
    return this._data.creditedAmount;
  }

  get resolvedUsdAmount() {
    return this.resolvedAmount * this.exchangeRate;
  }

  get currency() {
    return this._data.currency;
  }

  get exchangeRate() {
    return this._data.exchangeRate;
  }

  get shippingClaim() {
    return this._data.resolutionType;
  }

  get filedOn() {
    return formatDate(this._data.createdAt);
  }

  get reimburse() {
    return this._data.creditStore;
  }

  get resolvedBy() {
    return this._data.resolvedBy;
  }

  get resolvedDate() {
    return formatDate(this._data.createdAt);
  }

  get resolvedDateV2() {
    return formatDate2(this._data.createdAt);
  }

  get initialClaim() {
    return this._data.resolutionDescription;
  }

  get requestedResolution() {
    return this._data.resolutionType;
  }

  get uploadedPhotos() {
    return [];
  }

  get deletedAt() {
    return this._data.deletedAt;
  }
}
